import { render } from "./organizations.vue?vue&type=template&id=3045641f&ts=true"
import script from "./organizations.vue?vue&type=script&lang=ts"
export * from "./organizations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__